module.exports = __webpack_public_path__ + "img/slotmachine.d3d8ea10.png";